import PropTypes from 'prop-types';
import React from 'react';

import styles from './DayChip.module.scss';

const DayChip = ({
  label,
  count,
  selected = false,
  pill = false,
  compact = false,
  onClick,
  title,
  ariaLabel,
}) => (
  <button
    type="button"
    aria-pressed={selected}
    aria-label={ariaLabel}
    title={title}
    className={`${styles.chip} ${compact ? styles.chipCompact : ''} ${
      selected ? styles.chipSelected : ''
    }`}
    onClick={onClick}
  >
    {label}
    <span
      className={
        pill ? `${styles.countPill} ${compact ? styles.countPillCompact : ''}` : styles.count
      }
    >
      {count}
    </span>
  </button>
);

DayChip.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  pill: PropTypes.bool,
  compact: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default DayChip;
